<div class="container">
  <h1>You are the murderer!</h1>
  <p>Select a clue and means card from your deck below.</p>
  <div class="deck-container">
    <div class="fill-remaining-space"></div>
    <app-player-deck [(selectedClue)]="selectedClue" [(selectedMeans)]="selectedMeans" [player]="player"></app-player-deck>
    <div class="fill-remaining-space"></div>
  </div>
  <button class="select-button" mat-raised-button color="accent" (click)="selectCards()" cdkFocusInitial>Select cards</button>
</div>
